import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
// import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../navigationSection/RightSideNavigation";

import ReportsDashboardOne from "./reportsDashboard/ReportsDashboardOne";
// import ReportsDashboardTwo from "./reportsDashboard/ReportsDashboardTwo";
// import OffersReports from "./offerReports/OffersReports";
import EventsReports from "./eventReports/EventsReports";
import SeatingReportsDashboard from "./seatingReports/SeatingReportsDashboard";

import { Col } from "react-bootstrap";
import SVG from "react-inlinesvg";
import Media from "react-media";
import moment from "moment";
import ReportsDashboardOffers from "./reportsDashboard/ReportsDashboardOffers";
import ReportsDashboardEvents from "./reportsDashboard/ReportsDashboardEvents";
import ReportsDashboardOrders from "./reportsDashboard/ReportsDashboardOrders";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { BasicDateRangePicker } from "../../reusableComponents/selectFilter";
// import getCustomDate from "../../reusableComponents/selectFilter";

class MainReportsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openPax: false,
      showStatus: "All",
      showPax: "All",
      displayTab: "",
      rightSideTab: "reportsOne",
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      dateTo: moment(new Date()).format("YYYY-MM-DD"),
      dateFrom: moment(new Date()).format("YYYY-MM-DD"),
      reportType: "monthly",
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props?.casualDiningData ||
      props?.multiDiningData ||
      props?.fastFoodDiningData
    ) {
      let initdisplay = "reportsoffersOne";
      if (
        props?.casualDiningData?.seating?.value ||
        props?.multiDiningData?.seating?.value
      ) {
        initdisplay = "reportsOne";
      } else if (
        props?.casualDiningData?.ordering?.value ||
        props?.fastFoodDiningData?.ordering?.value ||
        props?.multiDiningData?.ordering?.value
      ) {
        initdisplay = "ordering";
      } else if (
        props?.casualDiningData?.event_management?.value ||
        props?.multiDiningData?.event_management?.value
      ) {
        initdisplay = "events";
      }
      if (state?.displayTab === "") return { displayTab: initdisplay };
    }
    return null;
  }

  /****************************************
   * @DESC Ope Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /****************************************
    @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatus: type,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPax: type,
      openPax: false,
    });
  };

  /****************************************
   * @DESC Button Show Status Handler
   ***************************************/
  buttonClickHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      displayTab: type,
      rightSideTab: type,
    });
  };

  reportTypeHandler = (type) => () => {
    this.setState({
      reportType: type,
    });
  };

  changeDate = (e) => this.setState({ dateFilter: e.target.value });
  onFromDateChange = (e) => this.setState({ dateFrom: e.target.value });
  onToDateChange = (e) => this.setState({ dateTo: e.target.value });

  render() {
    // console.log(this.state);
    const { dateFilter } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>
            {/* <div className="top-panel">
              <TopNavigationBarMobile
                displayLeft="backButton"
                backLink="/seatingdashboard"
                headText="Seating Report"
              />
            </div> */}
            <div className="right-side-panel">
              <RightSideNavigation />
              <Row className="align-items-center mb-5">
                <Col md={6} className="f24_700_HelveticaNeue">
                  Report Live Dashboard
                </Col>
                {/* <Col md={6} className="text-right"> */}
                {/* {this.state.displayTab === "reportsOne" ||
                  this.state.rightSideTab === "reportsTwo" ? ( */}
                {/* <TextField
                    type="date"
                    variant="outlined"
                    value={dateFilter}
                    onChange={this.changeDate}
                  /> */}
                {/* ) : null} */}
                {/* </Col> */}
              </Row>
              <Row>
                <div className="col-lg-4 d-flex flex-wrap seating-left-side-navigation text-center border-right">
                  {(this.props?.casualDiningData?.seating?.value ||
                    this.props?.multiDiningData?.seating?.value) && (
                    <div
                      onClick={(e) => this.buttonClickHandler(e, "reportsOne")}
                    >
                      <div
                        className={
                          this.state.displayTab === "reportsOne" ||
                          this.state.rightSideTab === "reportsTwo" ||
                          this.state.displayTab === "seatingDdashboard"
                            ? "newseating-dashboard-reusable-button mr-3 ml-3 newseating-dashboard-reusable-button-active"
                            : "newseating-dashboard-reusable-button mr-3 ml-3"
                        }
                      >
                        <SVG
                          src={require("../../../assets/images/LiveReports/seating.svg")}
                          alt="seating"
                        />
                      </div>
                      <div
                        className={
                          this.state.displayTab === "reportsOne" ||
                          this.state.rightSideTab === "reportsTwo" ||
                          this.state.displayTab === "seatingDdashboard"
                            ? "f14-500 text-red"
                            : "f14-500"
                        }
                      >
                        Seating
                      </div>
                    </div>
                  )}
                  {(this.props?.casualDiningData?.offer_management?.value ||
                    this.props?.fastFoodDiningData?.offer_management?.value ||
                    this.props?.multiDiningData?.offer_management?.value) && (
                    <div
                      onClick={(e) =>
                        this.buttonClickHandler(e, "reportsoffersOne")
                      }
                    >
                      <div
                        className={
                          this.state.displayTab === "reportsoffersOne" ||
                          this.state.displayTab === "reportsoffersTwo"
                            ? "newseating-dashboard-reusable-button mr-3 ml-3 newseating-dashboard-reusable-button-active"
                            : "newseating-dashboard-reusable-button mr-3 ml-3"
                        }
                      >
                        <SVG
                          src={require("../../../assets/images/LiveReports/offers.svg")}
                          alt="Offfers"
                        />
                      </div>
                      <div
                        className={
                          this.state.displayTab === "reportsoffersOne" ||
                          this.state.displayTab === "reportsoffersTwo"
                            ? "f14-500 text-red"
                            : "f14-500"
                        }
                      >
                        Offers
                      </div>
                    </div>
                  )}
                  {(this.props?.casualDiningData?.event_management?.value ||
                    this.props?.multiDiningData?.event_management?.value) && (
                    <div onClick={(e) => this.buttonClickHandler(e, "events")}>
                      <div
                        className={
                          this.state.displayTab === "events" ||
                          this.state.displayTab === "eventsDashboard"
                            ? "newseating-dashboard-reusable-button mr-3 ml-3 newseating-dashboard-reusable-button-active"
                            : "newseating-dashboard-reusable-button mr-3 ml-3"
                        }
                      >
                        <SVG
                          src={require("../../../assets/images/LiveReports/Events.svg")}
                          alt="seating"
                        />
                      </div>
                      <div
                        className={
                          this.state.displayTab === "events" ||
                          this.state.displayTab === "eventsDashboard"
                            ? "f14-500 text-red"
                            : "f14-500"
                        }
                      >
                        Events
                      </div>
                    </div>
                  )}
                  {(this.props?.casualDiningData?.ordering?.value ||
                    this.props?.fastFoodDiningData?.ordering?.value ||
                    this.props?.multiDiningData?.ordering?.value) && (
                    <div
                      onClick={(e) => this.buttonClickHandler(e, "ordering")}
                    >
                      <div
                        className={
                          this.state.displayTab === "ordering"
                            ? "newseating-dashboard-reusable-button mr-3 ml-3 newseating-dashboard-reusable-button-active"
                            : "newseating-dashboard-reusable-button mr-3 ml-3"
                        }
                      >
                        <SVG
                          src={require("../../../assets/images/LiveReports/Ordering.svg")}
                          alt="ordering"
                        />
                      </div>
                      <div
                        className={
                          this.state.displayTab === "ordering"
                            ? "f14-500 text-red"
                            : "f14-500 text-black"
                        }
                      >
                        Ordering
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-4 col-12 mobile-mt-4">
                  {this.state.reportType === "custom" && (
                    <div className="">
                      {/* <Col md={6} lg={6} xs={12}>
                        <div className="f12-500 mb-1">Starts Date</div>
                        <TextField
                          type="date"
                          className="w-100"
                          variant="outlined" 
                          onChange={this.onFromDateChange} 
                          InputProps={{
                            inputProps: { max: moment().format("YYYY-MM-DD") },
                          }}
                        />
                      </Col>
                      <Col md={6} lg={6} xs={12}>
                        <div className="f12-500 mb-1">Ends Date</div>
                        <TextField
                          type="date"
                          className="w-100"
                          variant="outlined"
                          onChange={this.onToDateChange}
                          InputProps={{
                            inputProps: { max: moment().format("YYYY-MM-DD") },
                          }}
                        />
                      </Col> */}
                      <BasicDateRangePicker
                        disabled={true}
                        maxDate={moment().format("YYYY-MM-DD")}
                        value={[
                          new Date(this.state.dateTo),
                          new Date(this.state.dateFrom),
                        ]}
                        getCustomDate={(data) => {
                          this.onFromDateChange({
                            target: {
                              value: moment(new Date(data[0])).format(
                                "YYYY-MM-DD"
                              ),
                            },
                          });
                          this.onToDateChange({
                            target: {
                              value: moment(new Date(data[1])).format(
                                "YYYY-MM-DD"
                              ),
                            },
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="col-lg-4 col-12 d-flex justify-content-end align-items-center row mobile-mt-2">
                  <div
                    className={`f18-500 cursor ${
                      this.state.reportType === "hourly" && "text-red"
                    } ml-2 mr-3`}
                    onClick={this.reportTypeHandler("hourly")}
                  >
                    Hourly
                  </div>
                  <div
                    className={`f18-500 cursor ${
                      this.state.reportType === "daily" && "text-red"
                    } mr-3`}
                    onClick={this.reportTypeHandler("daily")}
                  >
                    Daily
                  </div>
                  <div
                    className={`f18-500 cursor ${
                      this.state.reportType === "weekly" && "text-red"
                    } mr-3`}
                    onClick={this.reportTypeHandler("weekly")}
                  >
                    Weekly
                  </div>
                  <div
                    className={`f18-500 cursor ${
                      this.state.reportType === "monthly" && "text-red"
                    } mr-3`}
                    onClick={this.reportTypeHandler("monthly")}
                  >
                    Monthly
                  </div>
                  <div
                    className={`f18-500 cursor ${
                      this.state.reportType === "custom" && "text-red"
                    } mr-3`}
                    onClick={this.reportTypeHandler("custom")}
                  >
                    Custom
                  </div>
                </div>
              </Row>
              <hr />
              <div>
                {this.state.displayTab === "reportsOne" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOne
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.props.history.push("/seatingdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
                {/* {this.state.displayTab === "reportsTwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOne
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                    />
                  </div>
                ) : null} */}
                {this.state.displayTab === "reportsoffersOne" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOffers
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.props.history.push("/offer")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
                {/* {this.state.displayTab === "reportsoffersTwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    <ReportsDashboardOffers
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "seatingDdashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      onFromDateChange={this.onFromDateChange}
                      onToDateChange={this.onToDateChange}
                      onDateChange={this.changeDate}
                    />
                  </div>
                ) : null} */}
                {this.state.displayTab === "events" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> */}
                    <ReportsDashboardEvents
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "eventsDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}

                {this.state.displayTab === "eventstwo" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> */}
                    <ReportsDashboardEvents
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "eventsDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
                {this.state.displayTab === "ordering" ? (
                  <div className="w-100 bottom-side-panel-reports">
                    {/* <EventsReports /> */}
                    <ReportsDashboardOrders
                      dateFilter={dateFilter}
                      onClick={(e) =>
                        this.buttonClickHandler(e, "orderDashboard")
                      }
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}

                {this.state.displayTab === "seatingDdashboard" ? (
                  <div className="col-12 ">
                    <SeatingReportsDashboard />
                  </div>
                ) : null}

                {this.state.displayTab === "eventsDashboard" ? (
                  <div className="col-12 ">
                    <EventsReports
                      dateTo={this.state.dateTo}
                      dateFrom={this.state.dateFrom}
                      reportType={this.state.reportType}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state?.errors && state?.errors?.errors,

  /********* Casual Dining service *********/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  casualDiningData:
    state?.onboarding?.onboard_subscription_details?.casual_dining_status,

  /********* Fast Food Dining service *********/
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  fastFoodDiningData:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining_status,

  /********* Multi Dining service *********/
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  multiDiningData:
    state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status,
});

export default connect(mapStateToProps)(withRouter(MainReportsDashboard));
